<template >
  <div >
    <el-collapse-transition >
      <!--      ==={{ healthInfoList }}&#45;&#45;&#45;&#45;-->
      <s-form
          v-if="state==1"
          key="1"

          ref="form"
          :model="formDada"
          label-width="120px"
          v-loading="!commonsLoaded"
          element-loading-text="pocessing..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          :fill-height="false" >
        <el-row >

          <el-button
              type="text"
              @click="$emit('close')"
              style="float: right" >
            Go back to the calendar <i class="material-icons" >clear</i >

          </el-button >
        </el-row >
        <el-row >  <span
            v-if="ScheduleTrip"
            style="float: left;font-size: large" >Booking date <strong >{{ ScheduleTrip.humandate }}</strong ></span >
        </el-row >
        <h4 >How many persons are you booking for?</h4 >
        <el-row >
          <s-form-item
              label="Adults"
              :sz="8" >
            <fa
                fixed-width
                size="lg"
                icon="male"
                style="float:left" ></fa >
            <el-input-number
                @change="calcTotalCost()"
                v-model="formDada.adults"
                controls-position="right"
                :min="0" ></el-input-number >
          </s-form-item >
          <s-form-item
              label="Children (less than 12 years old)"
              :sz="8" >
            <fa
                fixed-width
                size="lg"
                icon="child"
                style="float:left" ></fa >
            <el-input-number
                @change="calcTotalCost()"
                v-model="formDada.children"
                controls-position="right"
                :min="0" ></el-input-number >
          </s-form-item >
          <s-form-item :sz="8" >
            <h4 >
              <small >Total Cost:</small >
              {{ formDada.bookedPrice }}&euro;
            </h4 >
          </s-form-item >
        </el-row >

        <h4 >Leaders Contact details</h4 >
        <s-form-item
            label="Name"
            :sz="24" >
          <mobile-input v-model="formDada.customer" ></mobile-input >
        </s-form-item >
        <s-form-item
            label="Email"
            :sz="12" >
          <mobile-input v-model="formDada.note_email" ></mobile-input >
        </s-form-item >
        <s-form-item
            label="Phone Number"
            :sz="12" >
          <mobile-input v-model="formDada.note_phone" ></mobile-input >
        </s-form-item >

        <s-form-item
            label="Place"
            :sz="13" >

          <s-remote-select
              v-model="formDada.ppid"
              class-model="pup"
              query-prop="q"
              label-prop="name"
              :safe-mode="true"
              @input="checkTimeMap"
              :extraQueryParams="{type:'1,5',sort:'Pup.type DESC,Pup.name'}"
              captionField="loc_name" >
            <template slot-scope="{item}" >
              {{ item.name }}
              <el-tag type="info" >{{ item.loc_name }}</el-tag >
            </template >

          </s-remote-select >
          <!--          <el-alert-->
          <!--              :closable="false"-->
          <!--              type="success"-->
          <!--              show-icon-->
          <!--              effect="dark"-->
          <!--              v-if="planedTime">{{ planedTime }}-->
          <!--          </el-alert>-->
          <!--          <el-alert-->
          <!--              :closable="false"-->

          <!--              show-icon-->
          <!--              effect="dark"-->
          <!--              v-else>If you can't find your place of stay just pick the resort location (eg.Laganas)-->
          <!--          </el-alert>-->

        </s-form-item >
        <s-form-item
            label="Room Num."
            :sz="5" >
          <mobile-input v-model="formDada.roomnum" ></mobile-input >
        </s-form-item >
        <s-form-item
            label="Do you need to pick you up?"
            :sz="6"
            pl >
          <el-checkbox
              :disabled="disableTransfer"
              v-model="formDada.mean"
              true-label="transfer"
              false-label="notransfer" >Yes
          </el-checkbox >
        </s-form-item >
        <s-form-item label="Comment" >
          <mobile-input v-model="formDada.note_generalNotes" ></mobile-input >
        </s-form-item >
        <!--        <s-form-item label="Please write down your names, ages and weight" >-->
        <!--          <el-input-->
        <!--              v-model="formDada.note_paxNotes"-->
        <!--              type="textarea"-->
        <!--              autosize-->
        <!--              :rows="2" ></el-input >-->
        <!--        </s-form-item >-->
        <!--        <s-form-item label="If there are any health issues please state them" >-->
        <!--          <el-input-->
        <!--              v-model="formDada.note_healthNotes"-->
        <!--              type="textarea"-->
        <!--              autosize-->
        <!--              :rows="2" ></el-input >-->
        <!--        </s-form-item >-->
        <s-form-item
            style="padding-bottom: 10px;"
            :sz="24" >
          <sf-button
              type="primary"
              @click="nextStep()"
              fit
              :disabled="!!overPax"
              style="float:right;" >
            Let's Book it
            <span class="material-icons" >arrow_forward</span >
          </sf-button >
        </s-form-item >
      </s-form >

      <ExtraInfo

          :key="healthInfoList_counter"
          v-else-if="state==2"
          :person-count="(formDada.children ? formDada.children * 1 : 0) + (formDada.adults ? formDada.adults * 1 : 0)"
          v-model="healthInfoList[healthInfoList_counter]"
          @back="nextStep(false)"
          @next="nextStep(true)"
          xdone="nextStep" />
      <CcDetailsForm
          v-else-if="state==3"
          :booking-data="formDada"
          key="visa"
          @done="nextStep" />

      <q-card
          key="21"
          style="width:100vw;max-width:1500px;padding: 0px"
          v-else >
        <q-card-section class="row items-center q-pb-none" >
          <q-space />
          <q-btn
              flat
              round
              dense
              v-close-popup >
            <i class="material-icons" >clear</i >
          </q-btn >
        </q-card-section >

        <q-card-section style="padding: 3px;">
          <h1 style="color: #00a9c3;font-size: 25px;line-height: 25px;" >Thank you for booking your adventure with as...</h1 >
          <div v-html="voucherData" ></div >
        </q-card-section >
      </q-card >
    </el-collapse-transition >
  </div >
</template >

<script >
import * as api from "~/api/resource";
import commons from "~/mixins/commons";
import funs_bookings from "~/mixins/funs_bookings";
import CcDetailsForm from "./CcDetailsForm";
import ExtraInfo from "./ExtraInfo";

let msgBox = null
// import CcDetailsForm from "./CcDetailsForm";
export default {
  components: {ExtraInfo, CcDetailsForm},
  // components: {CcDetailsForm},
  mixins: [commons,
           funs_bookings],
  name: "online-booking-form",
  props: {
    tripId: {
      type: Number,
      default: null,
    },
    adultPax: {
      type: Number,
      default: null,
    },
  },
  async mounted() {
    this.silentMessages = true
    this.state = 1
    this.healthInfoList_counter = 0
    var vm = this;
    await this.prepareLoggedData();
    this.formDada.adults = this.adultPax;
    this.formDada.tripid = this.tripId;
    this.calcTotalCost()
    this.loading = false;
  },
  data() {
    return {
      overPax: 0,
      pickupInfo: null,
      accontConfig: {hasCChandler: true},
      healthInfoList: [],
      planedTime: null,
      disableTransfer: false,
      // healthInfoList_counter: 0,
      // scheduleTripRequest: { with: "TripService" },
      commonHealthInfo: {},
      loading: true,
      voucherData: null,
      // state: 1,
      voucherDataReceived: false,
      errors: {},
      newBooking: null,
      pocessing: false,
      formDada: {mean: 'transfer'},
      selectedFlightId: null,
      arvFlightDate: null,
      depFlightDate: null,
    };
  },

  methods: {
    async checkTimeMap() {

      const ppid = this.formDada.ppid;

      if (!ppid) {
        this.formDada.mean = 'transfer'
        this.planedTime = null
        this.disableTransfer = false
        return;
      }
      const vm = this,
          timeData = await api.fetchObject("pup", {
            id: ppid,
            rel_trip_id: this.$route.query.selectedTrip,
          });

      if (timeData && timeData.trip_time && timeData.trip_time.calcedPPTimeMM) {
        this.pickupInfo = timeData
        _log_("checkTimeMap.0..", timeData);
        if (timeData.trip_time.time_not_set) {
          this.disableTransfer = true
          this.formDada.mean = 'notransfer'
        }
        else {
          this.disableTransfer = false
          this.formDada.mean = 'transfer'
        }
        this.planedTime = this.formDada.mean == 'notransfer' ? 'Please meet us at the starting point of our excursion  (' + this.ScheduleTrip.TripService.ppName + ') at ' + this.ScheduleTrip.TripService.humantime : 'Please be ready for pickup at ' + this.intToTime(this.pickupInfo.trip_time.calcedPPTimeMM);

        // if (
        //     !this.formDada.bookedTimeMM ||
        //     this.formDada.bookedTimeMM == "00:00"
        // )
        //   this.formDada.bookedTimeMM = this.planedTime;

      }
    },
    async nextStep(forward) {

      if (forward && forward.id) {
        this.formDada = forward

        await this.issueVoucher()//we are in the last step
      }

      const pax = (this.formDada.children ? this.formDada.children * 1 : 0) + (this.formDada.adults ? this.formDada.adults * 1 : 0);
      _log_('nextStep forward', forward, pax, this.healthInfoList_counter, this.healthInfoList_counter)
      if (this.state == 1) {
        if (!this.formDada.customer) {
          this.$message.error('Please provide a name')
          return
        }
        if (!this.formDada.note_email || this.formDada.note_email.indexOf('@') < 3 || this.formDada.note_email.indexOf('.') < -1) {
          this.$message.error('Please provide a valid email')
          return
        }
        this.commonHealthInfo = {fullName: this.formDada.customer}
        //prepare health info

        for (let iPax = 0; iPax < pax; iPax++)
          if (!iPax && !this.healthInfoList[iPax])
            this.healthInfoList.push({fullName: this.formDada.customer})
          else this.healthInfoList.push({})
        // ++this.healthInfoList_counter
        ++this.state
        return
      }
      //await this.issueVoucher();
      if (this.state == 2) {
        // if (!this.healthInfoList_counter) {
        //   this.commonHealthInfo = {fullName: this.formDada.customer}
        //   ++this.healthInfoList_counter
        //   return
        // }
        // else {


        if (this.healthInfoList_counter < pax - 1) {

          if (this.healthInfoList_counter >= 0) forward ? ++this.healthInfoList_counter : --this.healthInfoList_counter
          else {
            this.state = 1
            this.healthInfoList_counter = 0
            return
          }
          if (this.healthInfoList_counter <0 && !forward) {
            this.healthInfoList_counter = 0
            this.state = 1
            return
          }
          return
        }
        else {

          this.formDada.note_healthInfo = JSON.stringify(this.healthInfoList)
        }

        // }
        //handle info for health for every booked person
        // if (bookingData) this.formDada.note_helthInfo = bookingData
        if (this.accontConfig.hasCChandler) {
          if (!forward) {
            this.healthInfoList_counter = 0
            this.state = 1
            return
          }
          this.state = 3
          return
        }
        else {
          _log_('nextStep this.formDada', this.formDada)
          if (!this.formDada.ticketNum) this.formDada.ticketNum = '_id_'
          if (this.formDada.customer&&this.formDada.note_email)
            this.formDada = await this.saveBooking(true);
          else alert('!!! something is going wrong. We are so sorry. To avoid mistakes please go through the process again.')
        }
      }


    },
    async calcTotalCost() {
      this.formDada.coid = UserProfile.userRelCoId

      let sentData = JSON.parse(JSON.stringify(this.formDada))
      sentData.tripid = this.$route.params.tripServiseId
      const {data} = await api.fetchProcessor('pricerules/calcprices', sentData)
      if (data.results && data.results.price) {
        this.formDada.tickePriceAdult = data.results.pricerule.adultPrice
        this.formDada.ticketPriceKid = data.results.pricerule.kidPrice
        this.$set(this.formDada, 'tickePriceAdult', data.results.pricerule.adultPrice)
        this.$set(this.formDada, 'ticketPriceKid', data.results.pricerule.kidPrice)
        this.$set(this.formDada, 'bookedPrice', data.results.price)
        this.formDada.bookedPrice = data.results.price
        _log_('prices....', data.results.price)
      }

      // const ad = this.formDada.adults * this.formDada.tickePriceAdult,
      //     ch = this.formDada.children * this.formDada.ticketPriceKid;
      // this.formDada.bookedPrice = (isNaN(ch) ? 0 : ch) + (isNaN(ad) ? 0 : ad);
    },
    // async goBilling() {
    //   this.newBooking = await this.saveBooking(true);
    //
    //   this.state = 2;
    //   // _log_("hellloooo", out);
    // },
    async issueVoucher() {

      const out = await api.updateProcessor(
          "gate/emailonlinebooking",
          {sentEmail: true, ...this.formDada}
      );
      this.voucherData = out._ticket;
      this.state = 4;
      _log_("hellloooo", out);
    },
    // async saveBooking(stay, andNew) {
    //   this.pocessing = true;
    //   this.formDada = await api.updateProcessor(
    //     "vue_booking/update",
    //     this.formDada
    //   );
    //   this.$emit("done", this.formDada);
    //   if (andNew) {
    //     const rPrts = this.$route.path.split("/booking/");
    //     this.routeGo({ path: rPrts[0] + "/booking/new" });
    //   } else if (!stay) {
    //     const rPrts = this.$route.path.split("/booking/");
    //     this.routeGo({ path: rPrts[0] });
    //   }
    //   this.pocessing = false;
    // },
    // async removeBooking(andNew) {
    //   this.pocessing = true;
    //   try {
    //     this.formDada = await api.removeObject("vue_booking", this.formDada);
    //   } catch (error) {
    //     _log_("error", error);
    //     this.$message.error("Oops, " + error.message);
    //     this.pocessing = false;
    //     return;
    //   }

    //   this.$emit("delete", this.formDada);
    //   this.$emit("done", this.formDada);
    //   this.pocessing = false;
    // },
    // async loadBooking(bkid) {
    //   this.loading = true;
    //   bkid = bkid ? bkid : this.$route.params.bookingid;
    //   if (bkid)
    //     if (bkid == "new")
    //       this.formDada = await api.fetchObject("vue_booking", {
    //         tripid: this.ScheduleTrip.id
    //       });
    //     else
    //       this.formDada = await api.fetchObject("vue_booking", {
    //         id: bkid
    //       });
    //   this.loading = false;
    // }
  },

  watch: {
    last_booking_warning(v) {
      if (msgBox) {
        msgBox.close()
        msgBox = null
      }
      if (v) {
        const bkPax = (this.formDada.adults ? this.formDada.adults * 1 : 0)
        this.overPax = v.totalpax * 1 - v.capacity * 1
        const dff = bkPax - this.overPax
        // _log_("last_booking_warning...", bkPax, this.overPax, dff, v);
        if (dff && dff != '0') {
          msgBox = this.$message({
            showClose: true,
            dangerouslyUseHTMLString: true,
            duration: 8000,
            type: 'error',
            message: '<h3>Sorry but this excursion is full, we can only allow ' + dff + ' more persons to join this trip</h3>'

          })
        }
        // this.$message('Sorry but this excursion is full, we can only allow ' + dff + ' more persons to join this trip')
      }
      else this.overPax = 0
    },
    "formDada.mean"(v, ov) {
      // _log_("hello...", this.TripServise, v);
      if (v != ov) {
        if (v == 'notransfer' || this.pickupInfo.trip_time.time_not_set) this.planedTime = 'Please meet us at the starting point of our excursion  (' + this.ScheduleTrip.TripService.ppName + ') at ' + this.ScheduleTrip.TripService.humantime
        else this.planedTime = 'Please be ready for pickup at ' + this.intToTime(this.pickupInfo.trip_time.calcedPPTimeMM);
      }
    },
    "TripServise.price1": {
      async handler(v, ov) {
        // _log_("hello...", this.TripServise, v);
        if (v != ov) this.formDada.tickePriceAdult = v;
      },
      immediate: true,
    },
    "TripServise.price2": {
      async handler(v, ov) {
        // _log_("hello...", this.TripServise, v);
        if (v != ov) this.formDada.ticketPriceKid = v;
      },
      immediate: true,
    },
  },
  computed: {
    healthInfoList_counter: {
      get() {
        return this.$route.query.person ? this.$route.query.person * 1 : 0
      },
      set(v) {
        this.routeGo({query: {person: v}})
      }
    },
    state: {
      get() {
        return this.$route.query.step ? this.$route.query.step * 1 : 1
      },
      set(v) {
        this.routeGo({query: {step: v}})
      }
    }
  },
};
</script >
